import React from 'react';
import TicketDetail from '@/components/ticket/detail';

export default () => <TicketDetail />;
